var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7435 13.2584L13.2582 21.7437C12.9683 22.0336 12.4875 22.0336 12.1976 21.7437C11.9077 21.4538 11.9077 20.973 12.1976 20.683L20.6828 12.1978C20.9728 11.9079 21.4536 11.9079 21.7435 12.1978C22.0334 12.4877 22.0334 12.9685 21.7435 13.2584Z",
    fill: "#1C1F1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7435 21.7436C21.4536 22.0336 20.9728 22.0336 20.6828 21.7436L12.1976 13.2584C11.9077 12.9684 11.9077 12.4876 12.1976 12.1977C12.4875 11.9078 12.9683 11.9078 13.2582 12.1977L21.7435 20.683C22.0334 20.9729 22.0334 21.4537 21.7435 21.7436Z",
    fill: "#1C1F1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelicon);
export default __webpack_public_path__ + "static/media/cancelicon.098ee24ed10fdb62604f3007ec61d151.svg";
export { ForwardRef as ReactComponent };